<template>
    <div id="insights" class="uk-padding uk-height-viewport">
        <top-bar />
        <div class="uk-container-expand" uk-height-viewport="min-height: 500; expand: true;">
            <graph-row>
                <graph-container v-for="(graph, index) in graphLayout" :key="index">
                    <!-- Below is the component that will be shown
                         temporary their will be given a data attribute and labels attribute
                         this can be removed if the dataPath is working in collecting data. -->
                    <component
                        :is="graph ? graph.component : 'add-graph-box'"
                        :id="graph ? graph.id : ''"
                        :aggregator-path="graph ? graph.aggregatorPath : ''"
                        :chart-data="graph ? graph.chartData : ''"
                        :data-label="graph ? graph.dataLabel : ''"
                        :data-path="graph ? graph.dataPath : ''"
                        :description="graph ? graph.description : ''"
                        :filters="graph ? graph.filters : ''"
                        :graph-position="index"
                        :info-text="graph ? graph.infoText : ''"
                        :title="graph ? graph.title : ''"
                    />
                </graph-container>
            </graph-row>
        </div>
    </div>
</template>

<script lang="js">
import TopBar from "./TopBar.vue";
import GraphContainer from "./GraphContainer.vue";
import GraphRow from "./GraphRow.vue";
import NumberGraph from "./components/graphs/NumberGraph.vue";
import BarGraph from "./components/graphs/BarGraph.vue";
import FlagGraph from "./components/graphs/FlagGraph.vue";
import VerticalBarGraph from "./components/graphs/VerticalBarGraph.vue";
import LineGraph from "./components/graphs/LineGraph.vue";
import AppsConversationGraph from "./components/graphs/AppsConversationGraph.vue";
import AddGraphBox from "./components/add-graph/AddGraphBox.vue";
import TimeGraph from "./components/graphs/TimeGraph.vue";
import TimeLineGraph from "./components/graphs/TimeLineGraph.vue";

export default {
    name: "Home",
    components: {
        TopBar,
        GraphContainer,
        GraphRow,
        NumberGraph,
        VerticalBarGraph,
        BarGraph,
        FlagGraph,
        LineGraph,
        AppsConversationGraph,
        AddGraphBox,
        TimeGraph,
        TimeLineGraph,
    },
    computed: {
        graphLayout() {
            return this.$store.state.graphs.layout;
        },
    },
};
</script>
<style lang="scss">
#insights {
    @import "@/assets/scss/modules/insights/main";
}
</style>
